import { styled } from 'styled-components';
import { ModalWrapper } from '../Modal/view';

export const CustomModalWrapper = styled(ModalWrapper)<{ $isCompactLayout?: boolean }>`
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    max-height: ${(props) => (props.$isCompactLayout ? '204px' : '568px')};
    max-width: ${(props) => (props.$isCompactLayout ? '440px' : '962px')};
    box-sizing: border-box;
`;

export const Overlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.4);
`;
